import {
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from '../../../../../utils/page';

import {
    onClickActiveAll,
    onClickArchiveAll,
    onClickCreate,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from '../../../../../utils/form';
import { createLoading } from '../../../../../utils/loading';
import store from '../../../../../store/index';
import { reactive } from 'vue';


import {
    createColumnInput
} from '../../../../../components/table/c-table.logic';
import i18n from '../../../../../i18n';

export const actionPrefix = 'resource/v1/master/labMonitorProductGroupTopic';
export const routerPrefix = 'lab-physic-monitor-product-topic-methods';

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });

export const { isLoading, setIsLoading } = createLoading();

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t('model.samplingMonitorType.modelName'),
            dataIndex: 'refLabMonitorProductGroup.name', align: 'center'
        }),
        createColumnInput({
            title: () => i18n.global.t('model.labMonitorProductGroupTopic.refLabTopic'),
            dataIndex: 'refLabTopic.name',
            align: 'center'
        }),
        createColumnInput({
            title: () => i18n.global.t('model.labMonitorProductGroupTopic.nameMethod'),
            dataIndex: 'nameMethod',
            align: 'center'
        })
    ];
    return columns;
};

export const createFormTitle = ({ data }) => {
    return data.useForm?.modelRef?.name ? data.useForm.modelRef.name : i18n.global.t('button.create')
}

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) => onClickActiveAll({
                rowSelection,
                callActiveAll,
                state,
                onSearch: (search) => onSearch({ ...search, props }),
                setIsLoading
            })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) => onClickArchiveAll({
                rowSelection,
                callArchiveAll,
                state,
                onSearch: (search) => onSearch({ ...search, props }),
                setIsLoading
            })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) => onClickDeleteAll({
                rowSelection,
                callDeleteAll,
                state,
                onSearch: (search) => onSearch({ ...search, props }),
                setIsLoading
            })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [
        createManageExtraCreate({
            menuContext,
            onClick: () => onClickCreate({ routerPrefix })
        })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({ menuContext, onClick: ({ record }) => onClickEdit({ record, routerPrefix }) })
    ];
};

export const onSearch = ({ page }) => {
    setIsLoading(true);
    window.onSearch?.({ page });
    const sort = page.sort || [];
    const where = page.where || [];
    const criteria = {
        criteria: {
            ...page,
            data: [],
            where: [{
                name: `refLabMonitorProductGroup.refLabType.key`,
                operator: '=',
                type: 'String',
                value: 'labPhysic'
            }, ...where],
            sort: [...sort]
        }
    };
    return callSearch(criteria)
        .then(page => state.page = { ...page, where, sort })
        .finally(() => setIsLoading(false));

};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ['**']
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } }
});

